// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"BreadCrumbSp_breadcrumb__mqBJc","home-anchor":"BreadCrumbSp_home-anchor__3nbAr","slash":"BreadCrumbSp_slash__yOYzf","anchor":"BreadCrumbSp_anchor__GDvCa"};